<div class="flex" style="margin-top: 15px;">
  <div class="card" *ngIf="asset.technicalDetails">
    <ngx-json-viewer [json]="jsonData"></ngx-json-viewer>
  </div>
  <div class="card w-full" *ngIf="!asset.technicalDetails && !loadingTechnicalDetails">
    <p class="text-xl text-center p-6 font-italic">
      {{'empty.technicalDetails' | transloco}}
    </p>
  </div>
  <div class="card w-full" *ngIf="!asset.technicalDetails && loadingTechnicalDetails">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
